module.exports = __webpack_public_path__ + "img/1.72767723.svg";